import type { ViewerPermissionsV2 } from '@monorepo/accounts-management/app/src/user-management/types/viewerPermissionsV2.type';

export const viewerPermissionsV2 = {
    conversions: {
        create: false,
    },
    payments: {
        create: false,
        view: true,
    },
    payroll: {
        create: false,
        view: false,
    },
    beneficiaries: {
        create: false,
        view: true,
    },
    users: {
        invite: false,
        manage: false,
    },
    company: {
        manage: false,
    },
    cards: {
        manage: false,
        view: false,
    },
    billing: {
        manage: false,
    },
    approval: {
        manage: false,
    },
    bills: {
        view: true,
        manage: false,
    },
} satisfies ViewerPermissionsV2;
